<div class="container" cdkFocusInitial aria-modal="true" style="max-width: 510px;">
  <div mat-dialog-title class="dialog-title title">
    <h1 class="font-lang-10 ">{{title}}</h1>
    <button mat-icon-button aria-label="Close Dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    @if (fireDeleteType === FireDeleteType.SIMPLE) {
      <ng-container *ngTemplateOutlet="simpleDelete" />
    } @else if (fireDeleteType === FireDeleteType.COMPLEX) {
      <ng-container *ngTemplateOutlet="complexDelete" />
    } @else if (fireDeleteType === FireDeleteType.UNDO_MERGE) {
      <ng-container *ngTemplateOutlet="undoMerge" />
    } @else if (fireDeleteType === FireDeleteType.REPORT) {
      <ng-container *ngTemplateOutlet="reportDelete" />
    }
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row">
      <button aria-label="Close" class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      @if (fireDeleteType !== FireDeleteType.UNDO_MERGE) {
        <button aria-label="Delete" class="usa-button delete-button" (click)="onDelete()">
          <span style="color: #ffffff;"><fa-icon class="fa-sm" [icon]="faTrash"></fa-icon>&nbsp;&nbsp;Yes, Delete</span>
        </button>
      } @else {
        <button aria-label="Undo Merge" class="usa-button undo-button" style="max-width: 100% !important;" (click)="onUndoMerge()">
          <span style="color: #ffffff;"><fa-icon class="fa-sm" [icon]="faRotateLeft"></fa-icon>&nbsp;&nbsp;Yes, Undo Merge</span>
        </button>
      }
    </div>
  </div>
</div>

<ng-template #simpleDelete>
  <p>Are you sure you want to delete <strong>{{fireName}}</strong>?</p>
  <p style="color: #D60036;"><mat-icon fontIcon="error_outline" style="vertical-align: -6px;" /> This action cannot be undone!</p>
</ng-template>

<ng-template #complexDelete>
  <p>Deleting this fire will remove the assessment and its associated 2500-8 report(s) currently <i>In Progress</i> for <strong>{{fireName}}</strong>.</p>
  <p>Are you sure you want to <strong>delete this fire and its associated assessment report(s)</strong>?</p>
  <p style="color: #D60036;"><mat-icon fontIcon="error_outline" style="vertical-align: -6px;" /> All data will be deleted. This action cannot be undone!</p>
</ng-template>

<ng-template #undoMerge>
  <p>Are you sure you want to <strong>undo the merge for {{fireName}}</strong>?</p>
</ng-template>

<ng-template #reportDelete>
  <p>Are you sure you want to delete <strong>the 2500-8 report {{reportName}}</strong>?</p>
  <p style="color: #D60036;"><mat-icon fontIcon="error_outline" style="vertical-align: -6px;" /> All data will be deleted. This action cannot be undone!</p>
</ng-template>
